<template>
  <ConfirmReciept />
</template>

<script>
import ConfirmReciept from "@/components/3pl/Operations/Dispatch/confirm-reciept.vue";

export default {
  components: {
    ConfirmReciept,
  },
};
</script>

<style></style>